import { Injectable } from '@angular/core';
import { RoutePlannerService } from '../route-planner/route-planner.service';
import { RoutePlannerDataModel } from '../../models/route-model';
import { AARoutePlannerEvents, RouteValidationMessage, AAGoogleMapEvents, AARouteEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { RoutePlannerViaService } from '../../services/route-via/route-via.service';
import { LocationManagerService } from '../location-manager/location-manager.service';
import { AppError } from 'src/app/core/models/constants';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerInputService extends EventsService {
  private routeDataModel: RoutePlannerDataModel;
  public routeLocationMessage = '';

  constructor(
    private locationManager: LocationManagerService,
    private routePlannerService: RoutePlannerService,
    private eventsService: EventsService,
    private appService: AppService,
    private readonly routeViaService: RoutePlannerViaService
  ) {
    super();
    this.routeDataModel = this.routePlannerService.routeDataModel;
  }

  public initMap(params: any) {
    const fromValue = params[AARouterURL._FROM] || params[AARouterURL._FROM_PLACE];
    if (fromValue) {
      this.routeDataModel.FromLocation.setName(fromValue, this.routeDataModel.FromLocation.Name !== fromValue);
    } else {
      this.routeDataModel.FromLocation.reset();
    }

    const toValue = params[AARouterURL._TO] || params[AARouterURL._TO_PLACE];
    if (toValue) {
      this.routeDataModel.ToLocation.setName(toValue, this.routeDataModel.ToLocation.Name !== toValue);
    } else {
      this.routeDataModel.ToLocation.reset();
    }

    if (params[AARouterURL._VIA]) {
      this.routeViaService.applyViaRouteFromURL(params[AARouterURL._VIA]);
    } else {
      this.routeDataModel.resetVia();
    }

    if (params[AARouterURL._OPTIONS]) {
      this.routeDataModel.OptionsData.decodeURL(params[AARouterURL._OPTIONS]);
    } else {
      this.routeDataModel.OptionsData.reset();
    }

    // check if to location name has lat&lng then pre-load name.
    if (this.locationManager.toLocation.nameHasLatLng()) {
      this.appService.getGeoLocationByLatLng(this.locationManager.toLocation.latLng).subscribe((result) => {
        this.locationManager.toLocation.Name = result.locationName;
        this.onInitMap();
      });
    } else {
      this.onInitMap();
    }
  }

  private onInitMap = () => {
    if (this.locationManager.fromLocation.validName() || this.locationManager.toLocation.validName()) {
      this.routePlannerService.updateGoogleMap(false);
    } else {
      this.routePlannerService.reset();
    }
    // this.dispatch(AARouteEvents.ROUTE_READY);
  };

  validateAndUpdateMap(doNotShowError?: boolean): void {
    this.eventsService.dispatch(RouteValidationMessage.MAX_VIA_MESSAGE, '');
    if (this.locationManager.validateFromToLocation() && this.routeViaService.validateViaRoute()) {
      this.routePlannerService.updateGoogleMap();
    } else {
      if (!doNotShowError) {
        this.eventsService.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
        this.eventsService.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.VIA_ROUTE_MISSING);
      }
      this.eventsService.dispatch(AAGoogleMapEvents.RESET_MAP);
    }
  }

  onContextMenuRouteLocation() {
    if (this.locationManager.validateFromToLocation()) {
      this.eventsService.dispatch(RouteValidationMessage.MAX_VIA_MESSAGE, '');
      this.routePlannerService.updateGoogleMap();
    }
  }

  public reverseRoute(): void {
    if (this.locationManager.validateFromToLocation()) {
      this.routeDataModel.reverse();

      // rever via routes.
      this.eventsService.dispatch(AARoutePlannerEvents.REVERSE_ROUTE);

      if (!this.routeViaService.viaFlag) {
        this.routePlannerService.updateGoogleMap();
      }
    }
  }
}
